// extracted by mini-css-extract-plugin
export default {"pagination":"style_pagination__qvYJ9","pageItem":"style_pageItem__fVvHS","pageLink":"style_pageLink__LKGHh","active":"style_active__usf41"};